import PropTypes from 'prop-types';
import { useState, useContext } from 'react';
import { NoResultsFoundNotification } from './NoResultsFoundNotification.js';
import { NeedLevelLegend } from './NeedLevelLegend.js';
import { MapSearchHelper } from './MapSearchHelper.js';
import { LoadingIndicator } from './LoadingIndicator.js';
import { LocationSearchBox } from '../common/locationSearchBox.js';
import { makeSearchURL } from '../common/searchRequestUtils.js';
import { MapSearchButton } from './MapSearchButton.js';
import * as MapSearchUtils from './MapSearchUtils.js';
import { SearchToggle } from './SearchToggle.js';
import { MapSearchContext } from './MapSearchContext.js';
import { MapToggleButton } from './MapToggleButton.js';
import { LightBoxWrapper } from '../common/LightBoxWrapper.js';


export const MapSearchInput = function ({
    map,
    selectedMarker,
    noFundableResults,
    showNearbyProjectsHelper,
    locationSearchBoxRef,
    performNewLocationSuggestionSearch,
    isLoading,
    performNewSearchOnMapCenter,
    showSearchBox,
    setSearchBox,
    searchParams,
    locationSearchParams
}) {
    const [allowLocationSearchSubmit, setAllowLocationSearchSubmit] = useState(false);
    const context = useContext(MapSearchContext);

    const toggleSearch = function() {
        setSearchBox(!showSearchBox);
    };

    const submitLocationSearch = function () {
        if (allowLocationSearchSubmit && !isLoading) {
            locationSearchBoxRef.current.submit();
        }
    };

    const locationSearchBoxCallbacks = {
        changeURL: performNewLocationSuggestionSearch,
        makeSearchURL: makeSearchURL,
        setAllowLocationSearchSubmit: setAllowLocationSearchSubmit,
    };

    // TODO why is open/closed status dependent on `selectedMarker` if we don't use that anywhere else in this component?
    //  Do we actually rely on that class for anything, or could we delete it and unconditionally make this div
    //  `pointer-events: none`?
    return (
        <div className={'top-section ' + (!!selectedMarker ? 'open ' : 'closed ')}>
            <div className='search-input-container'>
                {!isLoading && noFundableResults ? <NoResultsFoundNotification/> : null}
                <div className="floating-search links form-redux">
                    <div className="input">
                        <SearchToggle searchParams={searchParams} locationSearchParams={locationSearchParams} />
                        <div className="search-area">
                            <LocationSearchBox
                                searchURL = {MapSearchUtils.DEFAULT_PROJECT_SEARCH_URL}
                                callbacks = {locationSearchBoxCallbacks}
                                ref = {locationSearchBoxRef}
                                directlyUpdateText = {true}
                            />
                            <MapSearchButton
                                allowLocationSearchSubmit={allowLocationSearchSubmit}
                                isLoading={isLoading}
                                submitLocationSearch={submitLocationSearch}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

MapSearchInput.propTypes = {
    selectedMarker: PropTypes.object,
    noFundableResults: PropTypes.bool,
    showNearbyProjectsHelper: PropTypes.bool,
    locationSearchBoxRef: PropTypes.object,
    performNewLocationSuggestionSearch: PropTypes.func,
    isLoading: PropTypes.bool,
    performNewSearchOnMapCenter: PropTypes.func,

    // From MapSearchResults, for use in SearchToggle
    searchParams: PropTypes.object.isRequired,
    // From MapSearchResults, for use in SearchToggle
    locationSearchParams: PropTypes.object,
};

/**
 * A MapSearchInput, but wrapped in a lightbox.
 */
export const MobileMapSearchInput = function ({
    selectedMarker,
    noFundableResults,
    showNearbyProjectsHelper,
    locationSearchBoxRef,
    performNewLocationSuggestionSearch,
    isLoading,
    performNewSearchOnMapCenter,
    showSearchBox,
    setSearchBox,
    searchParams,
    locationSearchParams,
    setLocationInputToggle
}) {
    const closeHandler = () => { setLocationInputToggle(false); };
    return (
        <LightBoxWrapper unMountHandler={closeHandler} additionalClasses="mobile-modal">
            <div className="mobile-search-box">
                <h3>Search by location</h3>
                <MapSearchInput
                    selectedMarker={selectedMarker}
                    noFundableResults={noFundableResults}
                    showNearbyProjectsHelper={showNearbyProjectsHelper}
                    locationSearchBoxRef={locationSearchBoxRef}
                    performNewLocationSuggestionSearch={performNewLocationSuggestionSearch}
                    isLoading={isLoading}
                    performNewSearchOnMapCenter={performNewSearchOnMapCenter}
                    showSearchBox={showSearchBox}
                    setSearchBox={setSearchBox}
                    searchParams={searchParams}
                    locationSearchParams={locationSearchParams}
                    setLocationInputToggle={setLocationInputToggle}
                />
            </div>
        </LightBoxWrapper>
    );
}
